<template>
  <div>
    <v-sheet class="text-center py-16">
      <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
      <p class="mt-4 text-caption">Kakao 로그인중</p>
    </v-sheet>

    <!-- SNS 로그인 신규 가입 dialog -->
    <v-dialog max-width="540" v-model="show_confirm_dialog" content-class="rounded-10" style="z-index: 999">
      <v-sheet class="rounded-10 pa-4">
        <p class="text-center mb-0">
          <v-icon size="80" color="#f2b8bf" class="">mdi-alert-circle-outline</v-icon>
        </p>

        <p class="text-center text-body mt-3 px-1" style="letter-spacing: 0px !important" v-html="$t('page.login.alert-info-new-member-guide')"></p>

        <div class="d-flex justify-space-between mt-6">
          <v-btn color="#ddd" class="rounded-10" dark width="48%" depressed @click="loginCancle()"> {{ $t("button.no") }} </v-btn>

          <v-btn color="#f2b8bf" class="rounded-10" dark width="48%" depressed @click="next_register()"> {{ $t("button.yes") }} </v-btn>
        </div>
      </v-sheet>
    </v-dialog>
    <v-dialog max-width="540" v-model="show_warn_dialog" content-class="rounded-10" style="z-index: 999">
      <v-sheet class="rounded-10 pa-4">
        <p class="text-center mb-0">
          <v-icon size="80" color="#f2b8bf" class="">mdi-alert-circle-outline</v-icon>
        </p>

        <p class="text-center text-body mt-3 px-1" style="letter-spacing: 0px !important">
          {{ warn_error_message }}
        </p>

        <div class="d-flex justify-center mt-6">
          <v-btn color="#f2b8bf" class="rounded-10" dark width="48%" depressed @click="loginCancle()"> {{ $t("button.ok") }} </v-btn>
        </div>
      </v-sheet>
    </v-dialog>
  </div>
</template>
<script>
import { mapMutations, mapActions } from "vuex"
import authService from "@/api/auth-service"

export default {
  data() {
    return {
      show_confirm_dialog: false,
      warn_error_message: "",
    }
  },

  computed: {
    show_warn_dialog: {
      get() {
        return !!this.warn_error_message
      },
      set(value) {
        if (!value) {
          this.warn_error_message = ""
        }
      },
    },
  },
  mounted() {
    this.kakaoLogin()
  },

  methods: {
    ...mapMutations(["ADD_TEMP_SNS_USER"]),
    ...mapActions(["login"]),

    async kakaoLogin() {
      const code = this.$route.query.code

      if (!code) {
        alert("카카오 인증 코드가 없습니다.")
        this.$router.replace("/auth/login")
        return
      }

      try {
        // 토큰 교환
        const axios = require("axios")
        const redirectUri = `${window.location.origin}/auth/kakao`

        const tokenRes = await axios.post(
          "https://kauth.kakao.com/oauth/token",
          new URLSearchParams({
            grant_type: "authorization_code",
            client_id: process.env.VUE_APP_KAKAO_JAVASCRIPT_KEY,
            redirect_uri: redirectUri,
            code: code,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            withCredentials: false,
          }
        )

        // 사용자 정보 가져오기
        const userResp = await axios.get("https://kapi.kakao.com/v2/user/me", {
          headers: {
            Authorization: `Bearer ${tokenRes.data.access_token}`,
          },
          withCredentials: false,
        })

        if (userResp.data) {
          const email = userResp.data.kakao_account?.email

          if (!email) {
            alert("email이 존재하지 않는 계정은 로그인이 불가합니다.")
            this.$router.replace("/auth/login")
            return
          }

          // URL state 파라미터에서 복원 (구글 로그인과 동일한 방식)
          let state = null
          if (this.$route.query.state) {
            state = JSON.parse(decodeURIComponent(atob(this.$route.query.state)))
          }

          // 기존 사용자 확인
          let user = await authService.checkDuplicateEmail(email)

          if (!user) {
            // 회원정보가 없음
            console.log("회원정보가 없음.")
            user = {
              user_id: email,
              name: userResp.data.kakao_account.profile.nickname,
              profile_image: userResp.data.kakao_account.profile.thumbnail_image_url,
              sns_id: userResp.data.id.toString(),
              provider_type: "kakao",
            }
            this.ADD_TEMP_SNS_USER(user)
            this.show_confirm_dialog = true
          } else {
            // 회원정보가 있음
            if (user.provider_type === "kakao") {
              // 기존 SNS 사용자 정보 업데이트
              try {
                user = {
                  ...user,
                  name: userResp.data.kakao_account.profile.nickname,
                  sns_id: userResp.data.id.toString(),
                  provider_type: "kakao",
                }
                await authService.updateSnsUserInfo(user)
              } catch (e) {
                console.log(e)
              }
            } else if (user.phone === "SNS 로그인") {
              // DB 이전의 호환을 위해서
              try {
                user = {
                  ...user,
                  name: userResp.data.kakao_account.profile.nickname,
                  sns_id: userResp.data.id.toString(),
                  provider_type: "kakao",
                }
                await authService.updateSnsUserInfo(user)
              } catch (e) {
                console.log(e)
              }
            } else {
              // 이미 가입된 계정 안내
              let prefix = "이메일 회원으로 가입된 계정입니다. "
              switch (user.provider_type.toLowerCase()) {
                case "google":
                  prefix = "구글 계정으로 가입된 계정입니다. "
                  break
                case "naver":
                  prefix = "네이버 계정으로 가입된 계정입니다. "
                  break
                default:
                  break
              }
              this.warn_error_message = prefix + "계정 정보를 확인하여 다시 로그인 해주세요.(" + user.user_id + ")"
              return
            }

            // JWT 로그인 시도
            try {
              const jwtResponse = await this.login({
                user_id: user.user_id,
                password: userResp.data.id.toString(),
              })

              if (jwtResponse.success) {
                // sns_profile_image를 별도로 저장하여 새로고침 시에도 유지
                this.$store.commit("login", {
                  ...user,
                  sns_profile_image: userResp.data.kakao_account.profile.thumbnail_image_url,
                  type: "SNS",
                })
                this.$gtag.event("login", { method: "Kakao" })

                if (state && state.callbackUrl) {
                  this.$router.replace(state.callbackUrl)
                } else {
                  this.$router.replace("/")
                }
              }
            } catch (jwtError) {
              console.error("JWT 로그인 실패:", jwtError)
              // sns_profile_image를 별도로 저장하여 새로고침 시에도 유지
              this.$store.commit("login", {
                ...user,
                sns_profile_image: userResp.data.kakao_account.profile.thumbnail_image_url,
                type: "SNS",
              })
              this.$gtag.event("login", { method: "Kakao" })
              this.$router.replace("/")
            }
          }
        } else {
          alert("카카오 로그인 정보를 가져오지 못해 인증에 실패하였습니다.")
          this.$router.replace("/auth/login")
        }
      } catch (e) {
        console.error(e)
        alert("인증 및 가입에 실패하였습니다.")
        this.$router.replace("/auth/login")
      }
    },

    next_register() {
      // URL state 파라미터에서 복원 (구글 로그인과 동일한 방식)
      let state = null
      if (this.$route.query.state) {
        state = JSON.parse(decodeURIComponent(atob(this.$route.query.state)))
      }
      console.log("state", state)

      this.$router.push({
        path: "/auth/join/agree",
        query: state || {},
      })
    },

    loginCancle() {
      this.$router.back()
    },
  },
}
</script>
